import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail } from "lucide-react";
import { SITE, SOLUTIONS, GROUPS } from "@/config/site";

export default function Footer() {
  return (
    <footer className="border-t border-silver/50 bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <img src={SITE.logo} alt="DJC Global" className="h-14 w-auto" width="150" height="52" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-ink/70">
              DJC Global connects businesses with specialized solutions — from cost savings and
              employee benefits to healthcare operations, AI marketing, and what comes next.
            </p>
            <div className="mt-6 space-y-2 text-sm">
              <a
                href={SITE.phoneHref}
                data-testid="footer-phone-link"
                className="flex items-center gap-2 font-semibold text-ink transition-colors hover:text-cobalt"
              >
                <Phone className="h-4 w-4 text-cobalt" /> {SITE.phone}
              </a>
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email-link"
                className="flex items-center gap-2 text-ink transition-colors hover:text-cobalt"
              >
                <Mail className="h-4 w-4 text-cobalt" /> {SITE.email}
              </a>
            </div>
          </div>

          <div className="lg:col-span-4">
            <p className="font-display text-[11px] font-bold uppercase tracking-[0.2em] text-cobalt">
              Solutions
            </p>
            <ul className="mt-4 grid gap-2 sm:grid-cols-2">
              {SOLUTIONS.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/solutions/${s.slug}`}
                    data-testid={`footer-solution-link-${s.slug}`}
                    className="text-sm text-ink/75 transition-colors hover:text-cobalt"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-display text-[11px] font-bold uppercase tracking-[0.2em] text-cobalt">
              Company
            </p>
            <ul className="mt-4 space-y-2">
              {[
                { to: "/our-approach", label: "Our Approach", id: "approach" },
                { to: "/about", label: "About DJC Global", id: "about" },
                { to: "/contact", label: "Contact", id: "contact" },
                { to: "/privacy", label: "Privacy Policy", id: "privacy" },
                { to: "/referral-disclosure", label: "Referral Disclosure", id: "referral" },
              ].map((l) => (
                <li key={l.id}>
                  <Link
                    to={l.to}
                    data-testid={`footer-${l.id}-link`}
                    className="text-sm text-ink/75 transition-colors hover:text-cobalt"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-6 border-t border-silver/50 pt-4 text-xs leading-relaxed text-ink/55">
              DJC Global may receive compensation from certain referrals.{" "}
              <Link to="/referral-disclosure" className="font-semibold text-cobalt hover:text-midnight">
                Disclosure
                <ArrowUpRight className="inline h-3 w-3" />
              </Link>
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-silver/50 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-ink/55">
            © {new Date().getFullYear()} DJC Global. Services are delivered by independent providers.
          </p>
          <div className="flex flex-wrap gap-x-5 gap-y-1 text-xs text-ink/55">
            {GROUPS.map((g) => (
              <span key={g.slug}>{g.name}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
